import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _createForOfIteratorHelper from "@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _typeof from "@babel/runtime/helpers/esm/typeof";
/* eslint-disable camelcase */
/* eslint-disable guard-for-in */
// @ts-ignore
import FT from 'fmp-tti';
import { onCLS, onFCP, onFID, onLCP, onTTFB } from 'web-vitals';
import { KEYS as keys, MAX_TIME, MIN_TIME, RANDOM as random } from "../constants";
import { getUuid } from "../utils";
import report from "../utils/report";
import { FMPTiming } from "./fmp";
import { calculateT2Time } from "./t2";
import { openWhiteScreen } from "./whiteScreen";
window.TTI_LIMIT = 10000;
var hasReportPerformance = false;
export function numFormat(num1, num2) {
  try {
    if (num1 > MIN_TIME && num2 >= MIN_TIME) {
      return num1 - num2 >= MAX_TIME ? MIN_TIME : (num1 - num2).toFixed(2);
    }
    return MIN_TIME;
  } catch (error) {
    return MIN_TIME;
  }
}
function isGreater(num) {
  var _num = Number(num);
  return _num > MIN_TIME ? num : MIN_TIME;
}
export function objectTransfer(data) {
  var str = '';
  for (var key in data) {
    if (!str) {
      str += "".concat(key, "=").concat(data[key]);
    } else {
      str += "|".concat(key, "=").concat(data[key]);
    }
  }
  return str;
}
export function analyzePerf() {
  var performance = window.performance;
  if (!performance || _typeof(performance) !== 'object') {
    return null;
  }
  var datas = {};

  // 由于普通情况下performance各属性为时间戳，所以需要计算出时间差
  keys.forEach(function (key) {
    // 以navigationStart为基准，计算各个时间差
    if (key === 'navigationStart') {
      datas[key] = MIN_TIME;
    } else {
      // 如果某个时间戳为0，或者不存在，那么就用0来代替
      if ((performance === null || performance === void 0 ? void 0 : performance.timing[key]) === 0 || !(performance !== null && performance !== void 0 && performance.timing[key])) {
        datas[key] = MIN_TIME;
      } else {
        var _Date, _Date2;
        // 以navigationStart为基准，计算各个时间差，用0兜底
        datas[key] = ((_Date = new Date(performance === null || performance === void 0 ? void 0 : performance.timing[key])) === null || _Date === void 0 ? void 0 : _Date.getTime()) - ((_Date2 = new Date(performance === null || performance === void 0 ? void 0 : performance.timing['navigationStart'])) === null || _Date2 === void 0 ? void 0 : _Date2.getTime()) || MIN_TIME;
      }
    }
  });

  // 使用 NT2 标准计算，safari不支持
  if (typeof window.PerformanceNavigationTiming === 'function') {
    // 部分浏览器会出现performance.getEntriesByType('navigation')[0]值为空的情况
    var nt2Timing = performance.getEntriesByType('navigation')[0];
    if (nt2Timing) {
      keys.forEach(function (key) {
        var _nt2Timing$key;
        datas[key] = +((_nt2Timing$key = nt2Timing[key]) === null || _nt2Timing$key === void 0 ? void 0 : _nt2Timing$key.toFixed(2)) || MIN_TIME;
      });
    }
  }
  return datas;
}
export function getLCP() {
  return new Promise(function (resolve) {
    try {
      onLCP(function (res) {
        resolve(res === null || res === void 0 ? void 0 : res.value);
      });
    } catch (error) {
      resolve(null);
    }
  });
}
export function getFCP() {
  return new Promise(function (resolve) {
    try {
      onFCP(function (res) {
        resolve(res === null || res === void 0 ? void 0 : res.value);
      });
    } catch (error) {
      resolve(null);
    }
  });
}
export function getFP() {
  return new Promise(function (resolve) {
    var fpEntry = performance.getEntriesByName('first-paint')[0];
    if (fpEntry && fpEntry.startTime) {
      resolve(fpEntry.startTime);
    }
    resolve(null);
  });
}
export function getFMP() {
  return new Promise(function (resolve) {
    try {
      new FMPTiming(function (res) {
        resolve(res === null || res === void 0 ? void 0 : res.fmpTiming);
      });
    } catch (error) {
      resolve(null);
    }
  });
}
export function getFID() {
  return new Promise(function (resolve) {
    try {
      onFID(function (res) {
        resolve(res === null || res === void 0 ? void 0 : res.value);
      });
    } catch (error) {
      resolve(null);
    }
  });
}
export function getTTFB() {
  return new Promise(function (resolve) {
    try {
      onTTFB(function (res) {
        resolve(res === null || res === void 0 ? void 0 : res.value);
      });
    } catch (error) {
      resolve(null);
    }
  });
}
export function getCLS() {
  return new Promise(function (resolve) {
    try {
      onCLS(function (res) {
        resolve(res === null || res === void 0 ? void 0 : res.value);
      });
    } catch (error) {
      resolve(null);
    }
  });
}
export function getTTI(performanceId) {
  try {
    FT.then(function (res) {
      var tti = res === null || res === void 0 ? void 0 : res.tti;
      report({
        logType: 'info',
        title: 'tti',
        msg: "tti=".concat(tti),
        extra: {
          performanceId: performanceId
        }
      });
    });
  } catch (error) {
    report({
      logType: 'error',
      title: 'tracker-error',
      msg: error
    });
  }
}
export function getTBT() {
  try {
    return new Promise(function (resolve) {
      var tbt = 0;
      var observer = new MutationObserver(function (mutationsList) {
        var _iterator = _createForOfIteratorHelper(mutationsList),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var mutation = _step.value;
            if (mutation.type === 'childList') {
              var _iterator2 = _createForOfIteratorHelper(mutation.addedNodes),
                _step2;
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  var addedNode = _step2.value;
                  if (typeof addedNode === 'function') {
                    var startTime = performance.now();
                    // @ts-ignore
                    addedNode();
                    var taskTBT = performance.now() - startTime;
                    tbt += taskTBT;
                  }
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
      setTimeout(function () {
        observer.disconnect();
        resolve(tbt);
      }, 2000);
    });
  } catch (error) {
    report({
      logType: 'error',
      title: 'tracker-error',
      msg: error
    });
  }
}
export function reportPerformance(_x) {
  return _reportPerformance.apply(this, arguments);
}
function _reportPerformance() {
  _reportPerformance = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(title) {
    var performanceId, fcpPromise, fmpPromise, ttfbPromise, lcpPromise, fpPromise, t2timePromise, _performance, performanceResult, i, redirect, dns, tcp, request, dom, domloading, domready, onload, result;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!hasReportPerformance) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return");
        case 2:
          performanceId = getUuid();
          _context.prev = 3;
          fcpPromise = getFCP();
          fmpPromise = getFMP();
          ttfbPromise = getTTFB();
          lcpPromise = getLCP();
          fpPromise = getFP(); // 获取TTI
          getTTI(performanceId);
          // 获取JST2
          t2timePromise = calculateT2Time(); // 白屏检测
          openWhiteScreen(function (status) {
            if (!status) {
              report({
                logType: 'error',
                title: 'white-screen',
                msg: "white-scree error",
                extra: {
                  performanceId: performanceId
                }
              });
            }
          }, {
            skeletonProject: false,
            whiteBoxElements: ['html', 'body', '#app', '#root']
          });
          _performance = analyzePerf();
          performanceResult = {};
          report({
            logType: 'info',
            title: 'analyzePerformance',
            msg: objectTransfer(_performance),
            extra: {
              performanceId: performanceId
            }
          });
          hasReportPerformance = true;
          for (i in _performance) {
            performanceResult[i] = _performance[i] >= MAX_TIME || !_performance[i] ? MIN_TIME : _performance[i];
          }
          redirect = numFormat(performanceResult.redirectEnd || MIN_TIME, performanceResult.redirectStart || MIN_TIME); // 4 - 3   重定向耗时
          dns = numFormat(performanceResult.domainLookupEnd || MIN_TIME, performanceResult.domainLookupStart || MIN_TIME); // 7 - 6   dns解析耗时
          tcp = numFormat(performanceResult.connectEnd || MIN_TIME, performanceResult.connectStart || MIN_TIME); // 1MIN_TIME - 8   tcp链接耗时
          request = numFormat(performanceResult.responseEnd || MIN_TIME, performanceResult.requestStart || MIN_TIME); // 13 - 11   资源请求加载耗时
          dom = numFormat(performanceResult.domComplete || MIN_TIME, performanceResult.responseEnd || MIN_TIME); // 18 - 13   解析dom树耗时
          domloading = numFormat(performanceResult.domInteractive || performanceResult.domLoading || MIN_TIME, performanceResult.fetchStart || MIN_TIME); // 15/12 - 5   白屏时间
          domready = numFormat(performanceResult.domContentLoadedEventEnd || MIN_TIME, performanceResult.fetchStart || MIN_TIME); // 17 - 5 首屏时间
          onload = numFormat(performanceResult.loadEventEnd || MIN_TIME, performanceResult.navigationStart || MIN_TIME); // 完整耗时 // 20 - 0
          result = "DNS=".concat(isGreater(dns), "|TCP=").concat(isGreater(tcp), "|redirect=").concat(isGreater(redirect), "|request=").concat(isGreater(request), "|parsingDom=").concat(isGreater(dom), "|domloading=").concat(isGreater(domloading), "|domready=").concat(isGreater(domready), "|onload=").concat(isGreater(onload), "|random=").concat(random); // antmonitor不能过滤，前端过滤
          if (!(onload === MIN_TIME || domready === MIN_TIME || onload > MAX_TIME)) {
            _context.next = 31;
            break;
          }
          report({
            logType: 'error',
            title: (title || 'pagePerformance') + '_error',
            msg: result,
            extra: {
              performanceId: performanceId
            }
          });
          return _context.abrupt("return");
        case 31:
          report({
            logType: 'info',
            title: title || 'pagePerformance',
            msg: result,
            extra: {
              performanceId: performanceId
            }
          });
        case 32:
          _context.t0 = report;
          _context.t3 = "fp=";
          _context.next = 36;
          return fpPromise;
        case 36:
          _context.t4 = _context.sent;
          _context.t2 = _context.t3.concat.call(_context.t3, _context.t4, "|fcp=");
          _context.next = 40;
          return fcpPromise;
        case 40:
          _context.t5 = _context.sent;
          _context.t1 = _context.t2.concat.call(_context.t2, _context.t5, "|jst2=");
          _context.next = 44;
          return t2timePromise;
        case 44:
          _context.t6 = _context.sent;
          _context.t7 = _context.t1.concat.call(_context.t1, _context.t6);
          _context.t8 = {
            performanceId: performanceId
          };
          _context.t9 = {
            logType: 'info',
            title: 'web-vitals',
            msg: _context.t7,
            extra: _context.t8
          };
          (0, _context.t0)(_context.t9);
          _context.t10 = report;
          _context.t13 = "fmp=";
          _context.next = 53;
          return fmpPromise;
        case 53:
          _context.t14 = _context.sent;
          _context.t12 = _context.t13.concat.call(_context.t13, _context.t14, "|lcp=");
          _context.next = 57;
          return lcpPromise;
        case 57:
          _context.t15 = _context.sent;
          _context.t11 = _context.t12.concat.call(_context.t12, _context.t15, "|ttfb=");
          _context.next = 61;
          return ttfbPromise;
        case 61:
          _context.t16 = _context.sent;
          _context.t17 = _context.t11.concat.call(_context.t11, _context.t16);
          _context.t18 = {
            performanceId: performanceId
          };
          _context.t19 = {
            logType: 'info',
            title: 'web-vitals',
            msg: _context.t17,
            extra: _context.t18
          };
          (0, _context.t10)(_context.t19);
          _context.next = 71;
          break;
        case 68:
          _context.prev = 68;
          _context.t20 = _context["catch"](3);
          report({
            logType: 'error',
            title: 'report-performance-error',
            msg: _context.t20,
            extra: {
              performanceId: performanceId
            }
          });
        case 71:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[3, 68]]);
  }));
  return _reportPerformance.apply(this, arguments);
}